import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { GetNotifications, ReadNotification } from "../Services/MainServices";

function extractRelativeUrl(url) {
  if (!url) return null;
  const index = url.indexOf("/api/");
  return url.slice(index + 5);
}

export default function useNotifications(initialEndpoint = "notifications/") {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [nextPage, setNextPage] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async (endpoint, append = false) => {
    setLoading(true);
    try {
      const res = await GetNotifications(endpoint);
      const { notifications: newNotis, unread_count } = res.data.results;

      setUnreadCount(unread_count);
      setNextPage(extractRelativeUrl(res.data.next));

      setNotifications((prev) => (append ? [...prev, ...newNotis] : newNotis));
    } catch (err) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData(initialEndpoint);
  }, [initialEndpoint, fetchData]);

  const loadMore = () => {
    if (nextPage) fetchData(nextPage, true);
  };

  const markAsReadLocally = (id) => {
    setNotifications((prev) =>
      prev.map((item) =>
        item.noti_id === id ? { ...item, is_read: true } : item
      )
    );
    setUnreadCount((prev) => Math.max(prev - 1, 0));
  };

  return {
    notifications,
    unreadCount,
    loading,
    hasMore: !!nextPage,
    loadMore,
    markAsReadLocally,
  };
}

export const useIntersection = (elementRef, onIntersect, options = {}) => {
  useEffect(() => {
    if (!elementRef.current) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        onIntersect();
      }
    }, options);

    observer.observe(elementRef.current);

    return () => {
      observer.disconnect();
    };
  }, [elementRef, onIntersect, options]);
};

export const useReadNotification = () => {
  const post = async (notiIds = []) => {
    try {
      const response = ReadNotification(notiIds);
      return response.data;
    } catch (error) {}
  };

  return { post };
};
